import {createPortError} from '../platform/port-error.js';
import {createSafetyKnowledgeEntry} from './safety-knowledge.js';

function clientRequired(client){
  if(typeof client?.from!=='function')throw new TypeError('Database client with from() is required');
  return client;
}
function topics(values=[]){
  if(!Array.isArray(values))throw new TypeError('topics must be an array');
  return [...new Set(values.map(value=>String(value??'').trim().toLowerCase()).filter(Boolean))].slice(0,20);
}
function fromRow(row={}){
  return createSafetyKnowledgeEntry({
    id:row.id,
    version:row.version,
    status:row.status,
    topics:row.topics||[],
    statement:row.statement,
    source:row.source_metadata,
    reviewNotes:row.review_notes,
    reviewedBy:row.reviewed_by,
    reviewedAt:row.reviewed_at,
    createdAt:row.created_at,
    retiredAt:row.retired_at
  });
}

export function createSupabaseSafetyKnowledgeRemote({client}={}){
  const db=clientRequired(client);

  async function retrieve({topics:requestedTopics=[]}={}){
    const wanted=topics(requestedTopics);
    let query=db
      .from('dymek_safety_knowledge')
      .select('id,version,status,topics,statement,source_metadata,review_notes,reviewed_by,reviewed_at,created_at,retired_at')
      .eq('status','validated')
      .is('retired_at',null)
      .order('id',{ascending:true})
      .order('version',{ascending:false});

    if(wanted.length===1)query=query.contains('topics',[wanted[0]]);
    else if(wanted.length>1)query=query.overlaps('topics',wanted);

    const {data,error}=await query;
    if(error)throw createPortError('DYMEK_KNOWLEDGE_UNAVAILABLE',{retryable:true});

    const latest=new Map();
    for(const raw of data||[]){
      const entry=fromRow(raw);
      const current=latest.get(entry.id);
      if(!current||entry.version>current.version)latest.set(entry.id,entry);
    }
    return Object.freeze([...latest.values()]);
  }

  return Object.freeze({retrieve});
}
